import PropTypes from 'prop-types'
import Link from 'components/link'
import PostCardRow from 'hello_baby/components/post-card-row'
import css from '../navbar.scss'

export const SubNav = ({ items, onCategoryClick }) => (
  <div className={css.subNav}>
    <ul className="list-unstyled">
      {items.map((item) => (
        <li key={item.title}>
          <Link to={item.path} onClick={() => onCategoryClick(item)}>
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  </div>
)

SubNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  onCategoryClick: PropTypes.func.isRequired,
}

export const Guides = ({ title, guides }) => (
  <div className={css.guidesContainer}>
    <p>{`Shop by ${title} Guide`}</p>
    <PostCardRow
      columns={4}
      navigateWithRouter={false}
      posts={guides.slice(0, 4)}
    />
  </div>
)

Guides.propTypes = {
  title: PropTypes.string.isRequired,
  guides: PropTypes.arrayOf(PropTypes.object).isRequired,
}
